import { SrIcon } from "@/components/ui/SrIcon";
import { describeSendFailure, parsePoSendError } from "@/lib/invoice-send";

/**
 * «Ikke sendt: <årsak>» under statusen for utkast PowerOffice nektet å sende.
 * Samme tekstkilde som opprett-dialogen; hele forklaringen ligger i title.
 */
export function InvoiceSendError({ error }: { error: string }) {
  const text = describeSendFailure(parsePoSendError(error));
  const reason = text.title.split(": ")[1];
  return (
    <span
      className="flex items-center gap-1 text-xs font-medium text-destructive mt-1 cursor-help"
      title={`${text.title}. ${text.explanation} ${text.action}`}
    >
      <SrIcon name="alert-triangle" className="w-3.5 h-3.5 shrink-0" />
      {reason ? `Ikke sendt: ${reason}` : "Ikke sendt"}
    </span>
  );
}
